<template>
  <section class="notice">
    <!--工具条-->
    <div v-show="isNotice">
      <el-col :span="24" class="notice_toolbar toolbar findform">
         <div class="main_container">
        <div class="fuji" @click="show3 = !show3">
          <p style="margin: 0;margin-left: -22px;" class="goodslist1">
            <span style="margin-left:31px;margin-top:5px">搜索/查询</span>
            <span class="goods_red"/>
          </p>
          <div style="position: absolute;right:-20px;top:-10px" class="sanjiao"></div>
        </div>
          <el-collapse-transition>
          <div style="padding:0px 12px" v-show="show3">
        <el-form :inline="true" :model="filters" style="margin-top:10px;position: relative;display:flex">
          <!-- 顶部搜索框 -->
          <el-form-item style="display:flex;width:32.5%" label="公告主题：" >
            <el-input :title="filters.key" v-model="filters.key" placeholder="请输入关键词"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <img src="../../assets/img/aicon10.png" alt @click="checkImg()" v-if="isCheck==true" />
            <img src="../../assets/img/aicon13.png" alt @click="checkImg()" v-else />
            始终置顶
          </el-form-item> -->
          <el-form-item style="display:flex;width:32.5%" label="发布时间：">
            <!-- <el-col :span="8"> -->
              <!-- <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="filters.startTime"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
                :editable = "false"
                :picker-options="pickerOptions"
                class='normal_width'
              ></el-date-picker> -->
            <!-- </el-col> -->
        
            <!-- <span class="line till" >至</span> -->
            <!-- <el-col :span="8"> -->
              <!-- <el-date-picker
                placeholder="选择时间"
                v-model="filters.endTime"
                style="width: 100%;"
                :editable = "false"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions2"
                class='normal_width'
              ></el-date-picker> -->
                <el-date-picker
                :title="value6"
              v-model="value6"
              style="width:100%"
                :editable="iseditable"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions2"
              type="daterange"
              range-separator="至"
               @change="changetime"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            ></el-date-picker>
            <!-- </el-col> -->
        
          </el-form-item>
          <el-form-item style="display:flex;width:32.5%">
            <el-button style="float:right;height:36px;line-hieght:1px" @click.native.prevent="onSubmit('filters')" class="toolbar_search">查询</el-button>
          </el-form-item>
        </el-form>
          </div>
          </el-collapse-transition>
          </div>
      </el-col>

      <!--列表-->
      <template>
        <el-col :span="24" class="notice_table main_container">
          <section class="model_section">
            <p class="model_top_title">平台公告</p>
            <el-button type="danger" @click="showNoticeAdd()" v-if="menuAction.indexOf(41)>-1"
            style="float: right;margin: 5px 10px 0 0;">+新增</el-button>
          </section>
          <div class="table_container">
            <div class="table_inner_container">
              <el-table
                :data="users"
                v-loading="listLoading"
                class="notice_tab"
                stripe
                border
              style="height:auto;max-height:500px"
             
               
              >
                <el-table-column label="序号" width="64" align="center">
                  <template scope="scope">
                    <span>{{scope.$index + 1}}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Title" label="主题" align="center">
                   <template scope="scope">
                  <span :title="scope.row.Title" :label="scope.row.Title" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.Title}}</span>
              </template>
                </el-table-column>
                <el-table-column label="内容"  align="center">
                  <template slot-scope="scope">
                    <div class="notice_content" style="height:41px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" :title="scope.row.NContent" :label="scope.row.NContent" v-html="scope.row.NContent"></div>
                  </template>
                </el-table-column>
                <el-table-column prop="OperatorName" label="发布者"  align="center">
                   <template scope="scope">
                  <span :title="scope.row.OperatorName" :label="scope.row.OperatorName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.OperatorName}}</span>
              </template>
                </el-table-column>
                <el-table-column prop="ObjName" label="发布对象"  align="center">
                      <template scope="scope">
                  <span :title="scope.row.ObjName" :label="scope.row.ObjName" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.ObjName}}</span>
              </template>
                </el-table-column>
                <el-table-column prop="SendTime" label="发布时间"  align="center">
                         <template scope="scope">
                  <span :title="scope.row.SendTime" :label="scope.row.SendTime" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;">{{scope.row.SendTime}}</span>
              </template>
                </el-table-column>
                <el-table-column label="操作"  fixed="right" width="340" align="center">
                  <template slot-scope="scope">
                    <div class="action_container">
                      <p @click="see(scope.row)"  v-if="menuAction.indexOf(42)>-1">
                        <i class="el-icon-edit-outline"></i>
                        编辑
                      </p>
                      <span v-if="menuAction.indexOf(43)>-1">
                        <p class="already" v-if="scope.row.IsTop" @click="zhiding(scope.row)">
                          <i class="el-icon-download"></i>
                          取消
                        </p>
                        <p v-else @click="zhiding(scope.row)">
                          <i class="el-icon-download" style="transform:rotate(180deg)"></i>
                          置顶
                        </p>
                      </span>
                      
                    </div>
                  </template>
                  >
                </el-table-column>
              </el-table>
                <el-col style="padding-top:10px" :span="24" class="toolbar_footer">
            <el-pagination
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :page-size="10"
              :total="total"
              :current-page="pageIndex"
              style="float:right;"
            ></el-pagination>
          </el-col>
            </div>
           
          </div>

         
        </el-col>
      </template>
    </div>
    <!--新增界面-->
    <el-col :span="24" class="add_notice pad_left" v-show="isAdd">
      <section class="model_section">
        <el-col :span="24" style>
          <p class="model_top_title">平台公告{{isEdit?'编辑':'新增'}}</p>
        </el-col>
      </section>
      <el-form :model="form" label-width="110px" ref="editForm">
              <el-form-item label="是否置顶：">
          <span class="whether">
            <p>
              <i>
                <img :src="isOk?src2:src1" alt @click="changeImg()" />
              </i>
              是
            </p>
            <p>
              <i>
                <img :src="isOk?src1:src2" alt @click="changeImg()" />
              </i>
              否
            </p>
          </span>
        </el-form-item>
                <el-form-item label="发布对象：">
          <el-select
            v-model="ReceivingTypeId"
            @change="objoption(ReceivingTypeId)"
            style="width:200px"
          >
            <el-option
              :label="item.name"
              :value="item.Id"
              v-for="(item,index) in receiveoption"
              :key="index"
            ></el-option>
            <!-- <el-option label="按角色" value="mini"></el-option>
            <el-option label="按用户" value="user"></el-option>-->
          </el-select>
          <el-select v-model="ObjId" style="width:200px" @change="selectobj(ObjId)">
            <el-option
              :label="item.name"
              :value="item.Id"
              v-for="(item,index) in objoptions"
              :key="index"
            ></el-option>
            <!-- <el-option label="c端" value="app"></el-option>
            <el-option label="共创" value="gong"></el-option>
            <el-option label="平台管家" value="tes"></el-option>-->
          </el-select>
        </el-form-item>
        <el-form-item label="发布主题：" prop="name" style="width:360px">
          <el-input v-model="form.Title" maxlength="50" style="width:400px" auto-complete="off" placeholder="请填写主题"></el-input>
        </el-form-item>
        <!-- 富文本 -->
        <el-form-item label="发布内容：" prop="name" style="width:90%">
          <quill-editor
            ref="text"
            v-model="form.NContent"
            class="myQuillEditor"
            :options="editorOption"
          />
        </el-form-item>

      </el-form>
      <div class="dialog-footer">
        <p @click="editSubmit()" v-if="save">保 存</p>
        <p @click="edit()" v-else>保 存</p>
        <p @click="showNot()">取 消</p>
      </div>
    </el-col>
  </section>
</template>

<!--分页-->
<script>
import util from "../../common/util";
import NProgress from "nprogress";
import { getUserListPage, removeUser, editUser, addUser } from "../../api/api";
//查询
import { messageList } from "../../api/api";
// 新增
import { addMessage } from "../../api/api";
//修改置顶
import { topMessage } from "../../api/api";
//修改公告
import { checkMessage } from "../../api/api";

export default {
  props: ['menuAction'],
  data() {
    return {
      show3:true,
      // 富文本
      editorOption: {
        placeholder: "请输入文本...",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 切换按钮
            ["blockquote", "code-block"],
            [{ header: 1 }, { header: 2 }], // 自定义按钮值
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }], // 上标/下标
            [{ indent: "-1" }, { indent: "+1" }], // 缩进
            [{ direction: "rtl" }], // 文本方向
            [{ size: ["small", false, "large", "huge"] }], // 自定义下拉
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // 具有主题默认值的下拉列表
            [{ font: [] }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      },
      isCheck: false,
      value6:"",
      iseditable:false,
      // 平台公告主页
      isNotice: true,
      // 平台公告新增
      isAdd: false,
      isEdit: false,
      filters: {
        key: "",
        startTime: "",
        endTime: ""
      },
      isTop: false,
      visible: false,
      users: [],
      total: 100,
      pageIndex: 1,
      listLoading: false,
      editFormVisible: false, //编辑界面显是否显示
      // editFormTtile: "编辑", //编辑界面标题
      //编辑界面数据
      form: {
        Title: "",
        NContent: ""
      },
      ReceivingTypeId: 0,
      ObjId: 0,
      receiveoption: [
        {
          Id: 0,
          name: "全部"
        },
        {
          Id: 1,
          name: "按角色"
        },
      ],
      objoptions: [
        {
          Id: 0,
          name: "全部"
        }
      ],
      wuliuoptions: [
        {
          Id: 1,
          Name: "第三方快递"
        },
        {
          Id: 2,
          Name: "商家快递"
        }
      ],

      editLoading: false,
      btnEditText: "提 交",
      // 是/否按钮
      isOk: true,
      src1: require("../../assets/img/bicon64_03.jpg"),
      src2: require("../../assets/img/bicon64_05.jpg"),
      editid: "",
      save: true,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      pickerOptions2: {
        disabledDate: time => {
          let beginDateVal = this.filters.startTime;

          if (beginDateVal) {
            return (
              time.getTime() <
              new Date(beginDateVal).getTime() - 1 * 24 * 60 * 60 * 1000
            );
          }
        }
      }
    };
  },
  methods: {
    changetime() {
      if(this.value6+""=="null"){
      this.value6 = ["",""]
    }
    this.filters.startTime = this.value6[0];
    this.filters.endTime = this.value6[1];
    },
    // 是否置顶
    checkImg() {
      this.isCheck = !this.isCheck;
      // this.isTop = this.isCheck
    },
    // 是否显示主页
    showNot() {
      this.isAdd = false;
      this.isNotice = true;
    },
    // 显示新增页面
    showNoticeAdd() {
      let OperatorId = this.$cookie.get("OperatorId");
      this.isNotice = false;
      this.isAdd = true;
      this.isEdit = false;
      this.form.Title = "";
      this.form.NContent = "";

      this.isOk = true;
      this.OperatorId = OperatorId;
      this.ReceivingTypeId = 0;
      this.ObjId = 0;
      this.save = true;
    },
    // 改变是否的图片
    changeImg() {
      this.isOk = !this.isOk;
    },
    //删除
    handleDel: function(row) {
      var _this = this;
      this.$confirm("确认删除该记录吗?", "提示", {
        //type: 'warning'
      })
        .then(() => {
          _this.listLoading = true;
          NProgress.start();
          let para = { id: row.id };
          removeUser(para).then(res => {
            _this.listLoading = false;
            NProgress.done();
            this.$swal({
              type:"success",
              text:"删除成功"
            })
            _this.getUsers();
          });
        })
        .catch(() => {});
    },
    //新增
    editSubmit: function() {
      if(this.form.Title ==""){
        this.$swal({
          type:"warning",
          text:"请输入发布主题"
        })
        return false
      }else if(this.form.NContent ==""){
        this.$swal({
          type:"warning",
          text:"请输入发布内容"
        })
        return false
      }
      var _this = this;
      let OperatorId = _this.$cookie.get("OperatorId");
      var addParams = {
        Title: _this.form.Title,
        NContent: _this.form.NContent,
        IsTop: _this.isOk,
        OperatorId: OperatorId,
        ReceivingTypeId: _this.ReceivingTypeId,
        ObjId: _this.ObjId
      };
      addMessage(addParams).then(data => {
        if(data.ResultCode == 1){
        this.$swal({
          text:"保存成功",
          type:"success"
        })
        this.isNotice = true;
        this.isAdd = false;
        // this.pageIndex = 1;
        this.getmessagelist();
         }
      });
    },
    //修改置顶
    zhiding(scope) {
      var that = this;
      var addParams = {
        id: scope.Id,
        isTop: !scope.IsTop
      };
      topMessage(addParams).then(data => {
        scope.IsTop?
        this.$swal({
          text:"取消成功",
          type:"success"
        })
        :this.$swal({
          text:"置顶成功",
          type:"success"
        })
        that.getmessagelist();
      });
    },
    //查看
    see(scope) {
      this.isNotice = false;
      this.isAdd = true;
      this.isEdit = true;
      this.form.Title = scope.Title;
      this.form.NContent = scope.NContent;
      this.OperatorId = this.$cookie.get("OperatorId");
      this.ReceivingTypeId = scope.ReceivingTypeId;
      if (this.ReceivingTypeId == 0) {
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          }
        ];
        this.ObjId = scope.ObjId;
      } else if (this.ReceivingTypeId == 1) {
        this.ObjId = scope.ObjId;
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          },
          {
            Id: 1,
            name: "c端"
          },
          {
            Id: 2,
            name: "共创端"
          },
          {
            Id: 3,
            name: "平台管家"
          }
        ];
      } else if (this.ReceivingTypeId == 2) {
        this.ObjId = scope.ObjId;
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          },
          {
            Id: 1,
            name: "新人"
          },
          {
            Id: 2,
            name: "非新人非VIP"
          },
          {
            Id: 3,
            name: "VIP"
          }
        ];
      }
      this.isOk = scope.IsTop;
      this.editid = scope.Id;
      this.save = false;
    },

    edit() {
      var _this = this;
      let OperatorId = _this.$cookie.get("OperatorId");
      var addParams = {
        Title: _this.form.Title,
        NContent: _this.form.NContent,
        IsTop: _this.isOk,
        OperatorId: OperatorId,
        ReceivingTypeId: _this.ReceivingTypeId,
        id: _this.editid,
        ObjId: _this.ObjId
      };
      checkMessage(addParams).then(data => {
        if(data.ResultCode == 1){
          this.$swal({
            text:"保存成功",
            type:"success"
          })
          this.isNotice = true;
          this.isAdd = false;
          // this.pageIndex = 1;
          this.getmessagelist();
        }
      });
    },
    //接收类型的id
    objoption(id) {
      this.ReceivingTypeId = id;

      if (id == 0) {
        this.ObjId = 0;
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          }
        ];
      } else if (id == 1) {
        this.ObjId = 0;
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          },
          {
            Id: 1,
            name: "c端"
          },
          {
            Id: 2,
            name: "共创端"
          },
          {
            Id: 3,
            name: "平台管家"
          }
        ];
      } else if (id == 2) {
        this.ObjId = 0;
        this.objoptions = [
          {
            Id: 0,
            name: "全部"
          },
          {
            Id: 1,
            name: "新人"
          },
          {
            Id: 2,
            name: "非新人非VIP"
          },
          {
            Id: 3,
            name: "VIP"
          }
        ];
      }
    },
    //接收对象的id
    selectobj(id) {
      this.ObjId = id;
    },
    onSubmit: function() {
      this.pageIndex = 1;
      this.getmessagelist();
    },
    p(s) {
      return s < 10 ? "0" + s : s;
    },

    getmessagelist() {
      var _this = this;

      var noticeParams = {
        key: this.filters.key,
        isTop: this.isCheck,
        startTime: this.filters.startTime,
        endTime: this.filters.endTime,
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      messageList(noticeParams)
        .then(data => {
          _this.users = data.ResultObj;
          _this.total = data.RowsCount;
        })
        .catch(err => {
          _this.users = [];
        });
    },

    //分页显示
    handleCurrentChange(val) {
      let that = this;
      that.pageIndex = val;
      this.getmessagelist();
    }
  },
  created() {
    this.getmessagelist();
  },
  watch: {
    menuAction: function(val){
      this.menuAction = val
    }
  },
};
</script>

<style scoped>
.el-input__inner {
  background-color: #fff;
  border: 1px solid #f2f2f2;
}
.notice .notice_toolbar {
  height: auto;
  color: #404040;
}

/* 时间  */
/* .notice_toolbar .line {
  margin-left: 10px;
  line-height: 36px;
} */
/* 时间图标 */
/* .notice_toolbar .line img{
  margin-top:8px
} */
/* 查询按钮 */
.notice_toolbar .el-button {
  background-color: #F56C6C;
  margin-left: 0;
  color: #fff;
  width: 78px;
  border-color: #ff4949;
}
/* 内容表格 */
.notice_table {
  width: 99.5%;
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  position: relative;
  margin-top: 10px;
}
/* 标题 */

/* 平台公告 */
.notice_table .el-col-22 p {
  width: 80px;
  height: 55px;
 
  font-size: 14px;
  font-weight: bold;
  color: #2a2a2a;
  margin-left: 22px;
  line-height: 55px;
  border-bottom: 1px solid #F56C6C;
  margin-top: 0;
}
/* 新增按钮 */
.notice_table .el-col-2 p {
  width: 104px;
  height: 36px;
  background-color: #F56C6C;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  cursor: pointer;
}
/* 表格 */
.notice_tab {
  box-shadow: 0 0 0 0;
  width: 100%;
  margin: 0 auto;
}
/* 表格操作 */
.notice_tab p {
  float: left;
  color: #677c9d;
  width: 20%;
}
.notice_tab p.already {
  color: #929599;
}
.notice_tab p:first-child {
  margin-left: 30%;
}

/* 新增页面 */
.add_notice {
  background-color: #ffffff;
  box-shadow: 0px 1px 10px 0px rgba(14, 5, 10, 0.1);
  position: relative;
  margin-top: 20px;
}

/* 是否置顶 */
.add_notice .whether p {
  float: left;
  padding: 0;
  font-size: 12px;
  line-height: 12px;
  margin: 7px 42px 0 0;
  vertical-align: middle;
}
/* 选择框 */
.add_notice .whether p i {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
  margin-right: 10px;
}
.add_notice .whether p img {
  width: 100%;
  height: 100%;
}
/* 富文本 */
.add_notice .rich_text {
  width: 100%;
  height: 200px;
  border-radius: 3px;
  border: solid 1px #d2d2d2;
}
</style>



// WEBPACK FOOTER //
// notice.vue?1934203f